import React, { useState } from "react";

import { useNavigate } from "react-router-dom";

//import components
import { Footer, Navbar, SearchBar } from "../../Components";

//assets
import HeroImage from "../../Assets/background-img2.png";
import BackgroundImage from "../../Assets/background-img3.png";

export default function AboutUsPage() {
  const navigate = useNavigate();
  return (
    <>
      <Navbar />
      {/* hero section */}
      <div className="mt-14 relative overflow-x-hidden">
        <img
          className="object-cover w-full max-w-full md:h-auto h-[400px] object-center"
          src={HeroImage}
          alt="hero-img"
        />
        <div className="!absolute inset-0 flex flex-col justify-center items-center text-center gap-2 md:px-20 px-5">
          <p className="font-georgia text-[32px] sm:text-[45px] md:text-[55px] text-white leading-tight">
            Wir sind <br />
            ImmoInterest
          </p>
          <p className="text-white font-helvetica text-[14px] sm:text-[16px] md:text-[18px]">
            Alles, was du über Uns wissen musst.
          </p>
        </div>
      </div>

      {/* about section */}
      <div className="bg-gradient-to-b from-white to-gray-50 py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          {/* Main Content */}
          <div className="grid lg:grid-cols-2 gap-12 items-center mb-20">
            <div className="order-2 lg:order-1">
              <h2 className="lg:text-[48px] text-3xl font-georgia text-primary mb-6">
                Über ImmoInterest
              </h2>
              <p className="text-[16px] font-helvetica text-gray-700 leading-relaxed mb-6">
                Ihre zentrale Plattform für Immobilien. Inserieren Sie Ihre Objekte, 
                durchsuchen Sie aktuelle Angebote oder beauftragen Sie uns mit der 
                gezielten Suche nach Ihrer Wunschimmobilie.
              </p>
              <div className="bg-primary/5 border-l-4 border-primary p-4 rounded-r-lg">
                <p className="text-[15px] font-helvetica text-gray-700 italic">
                  Maximale Flexibilität für Ihre Immobiliensuche – von der eigenständigen Recherche bis zur individuellen Betreuung.
                </p>
              </div>
            </div>
            <div className="order-1 lg:order-2">
              <img
                className="object-cover w-full rounded-2xl shadow-2xl"
                src={BackgroundImage}
                alt="background-img"
              />
            </div>
          </div>

          {/* Feature Cards */}
          <div className="grid md:grid-cols-3 gap-8 mt-12">
            {/* Inserieren */}
            <div className="bg-white rounded-xl shadow-lg p-8 hover:shadow-xl transition-shadow duration-300 border border-gray-100">
              <div className="bg-primary/10 w-16 h-16 rounded-full flex items-center justify-center mb-6">
                <svg className="w-8 h-8 text-primary" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4v16m8-8H4" />
                </svg>
              </div>
              <h3 className="text-2xl font-georgia text-primary mb-4">
                Inserieren
              </h3>
              <p className="text-[15px] font-helvetica text-gray-700 mb-4">
                Stellen Sie Ihre Immobilie auf unserer Plattform ein und erreichen Sie potenzielle Käufer oder Mieter.
              </p>
              <ul className="space-y-3 text-[14px] font-helvetica text-gray-700">
                <li className="flex items-start">
                  <span className="text-primary mr-2 mt-1">✓</span>
                  <span>Einfache Inseratserstellung</span>
                </li>
                <li className="flex items-start">
                  <span className="text-primary mr-2 mt-1">✓</span>
                  <span>Große Reichweite</span>
                </li>
                <li className="flex items-start">
                  <span className="text-primary mr-2 mt-1">✓</span>
                  <span>Direkte Kontaktaufnahme</span>
                </li>
              </ul>
            </div>

            {/* Inserate finden */}
            <div className="bg-white rounded-xl shadow-lg p-8 hover:shadow-xl transition-shadow duration-300 border border-gray-100">
              <div className="bg-primary/10 w-16 h-16 rounded-full flex items-center justify-center mb-6">
                <svg className="w-8 h-8 text-primary" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
                </svg>
              </div>
              <h3 className="text-2xl font-georgia text-primary mb-4">
                Inserate finden
              </h3>
              <p className="text-[15px] font-helvetica text-gray-700 mb-4">
                Durchsuchen Sie aktuelle Immobilienangebote und finden Sie Ihr Traumobjekt.
              </p>
              <ul className="space-y-3 text-[14px] font-helvetica text-gray-700">
                <li className="flex items-start">
                  <span className="text-primary mr-2 mt-1">✓</span>
                  <span>Umfangreiche Filteroptionen</span>
                </li>
                <li className="flex items-start">
                  <span className="text-primary mr-2 mt-1">✓</span>
                  <span>Aktuelle Angebote</span>
                </li>
                <li className="flex items-start">
                  <span className="text-primary mr-2 mt-1">✓</span>
                  <span>Detaillierte Informationen</span>
                </li>
              </ul>
            </div>

            {/* Suchauftrag */}
            <div className="bg-white rounded-xl shadow-lg p-8 hover:shadow-xl transition-shadow duration-300 border border-gray-100">
              <div className="bg-primary/10 w-16 h-16 rounded-full flex items-center justify-center mb-6">
                <svg className="w-8 h-8 text-primary" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2" />
                </svg>
              </div>
              <h3 className="text-2xl font-georgia text-primary mb-4">
                Suchauftrag
              </h3>
              <p className="text-[15px] font-helvetica text-gray-700 mb-4">
                Nichts Passendes gefunden? Beauftragen Sie uns mit der gezielten Suche nach Ihrer Wunschimmobilie.
              </p>
              <ul className="space-y-3 text-[14px] font-helvetica text-gray-700">
                <li className="flex items-start">
                  <span className="text-primary mr-2 mt-1">✓</span>
                  <span>Individuelle Anforderungen</span>
                </li>
                <li className="flex items-start">
                  <span className="text-primary mr-2 mt-1">✓</span>
                  <span>Professionelle Objektsuche</span>
                </li>
                <li className="flex items-start">
                  <span className="text-primary mr-2 mt-1">✓</span>
                  <span>Persönliche Betreuung</span>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </>
  );
}
